import React from "react";
import { Row, Col, Dropdown, OverlayTrigger, Tooltip } from "react-bootstrap";
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip as RechartsTooltip, Legend, ResponsiveContainer } from "recharts";
import OrganizationStatsChart from "../../../Components/common/OrganizationStatsChart";
import RegisterChart from "../../../Components/common/RegisterChart";
import ActivityChart from "../../../Components/common/ActivityChart";
import CustomCarousel from "../../../Components/common/CustomCarousel";
import { FilterIcon, NoDataMessage, LoadingMessage } from "../DashboardMessages";


export const OrganizationsView = (props) => {
  const {
    isLoading, showOrganisationDashboardError, staffStatsData,
    organisationDashboardSharedVideoPerSchoolStatus,
    organisationDashboardSharedVideoPerSchool, fallbackThumb,
    organisationDashboardCategoryPerSchool, usageHoursData, hasUsageHoursData,
    activityData, hasActivityData, registerData, userData, categoryData,
    trendingTags, setSortTags, sortTags, videoData, sortBy, setSortBy,
    recentClasses, totalClassesCount, setSortClasses, sortClasses, sortClassOptions,
    sortOrder, setSortOrder, recentCollections, totalCollectionsCount, sortCollectionOptions,
    setSortCollections, sortCollections, recentStaff, totalStaffCount,
    activeRole, isDateFilter, formatLastActive, navigate, Encryptedid, groupData
  } = props;

  return (
          <>
            <Row className="mb-4">
              <Col xxl={5} lg={12} xl={5} className="mt-4">
                <div className="cmn-card-color h-100">
                  <div className="details-chart">
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      <h2 className="f-24 m-0" style={{ color: "#2B3674", fontSize: "24px" }}>
                        Usage (Hours)
                      </h2>
                    </div>
                    <div className="m-2">
                      {isLoading ? (
                        <LoadingMessage />
                      ) : showOrganisationDashboardError ? (
                        <LoadingMessage message="We couldn't load organisation dashboard data right now." />
                      ) : hasUsageHoursData ? (
                        <ResponsiveContainer height={300}>
                          <BarChart
                            data={usageHoursData}
                            margin={{ top: 20, right: 30, left: 20, bottom: 5 }}
                            barGap={9}
                          >
                            <CartesianGrid
                              strokeDasharray="3 3"
                              vertical={false}
                              stroke="#F4F7FE"
                            />
                            <XAxis
                              dataKey="organisation"
                              axisLine={false}
                              tickLine={false}
                              tick={{ fill: "#A3AED0", fontSize: 12 }}
                            />
                            <YAxis
                              axisLine={false}
                              tickLine={false}
                              tick={{ fill: "#A3AED0", fontSize: 12 }}
                            />
                            <RechartsTooltip
                              contentStyle={{
                                borderRadius: "10px",
                                border: "none",
                                boxShadow:
                                  "0px 18px 40px rgba(112, 144, 176, 0.12)",
                              }}
                            />
                            <Legend iconType="circle" />
                            <Bar
                              dataKey="staff"
                              fill="#2B3674"
                              radius={[4, 4, 0, 0]}
                              name="Staff"
                              barSize={40}
                            />
                            <Bar
                              dataKey="parents"
                              fill="#D200A5"
                              radius={[4, 4, 0, 0]}
                              name="Parents"
                              barSize={40}
                            />
                            <Bar
                              dataKey="learners"
                              fill="#A3AED0"
                              radius={[4, 4, 0, 0]}
                              name="Learners"
                              barSize={40}
                            />
                          </BarChart>
                        </ResponsiveContainer>
                      ) : (
                        <NoDataMessage />
                      )}
                    </div>
                  </div>
                </div>
              </Col>
              <Col xxl={7} lg={12} xl={7} className="mt-4">
                <div className="cmn-card-color h-100">
                  <div className="details-chart">
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      <h2 className="f-24 m-0" style={{ color: "#2B3674", fontSize: "24px" }}>
                        Number of Staff Accounts
                      </h2>
                    </div>
                    <div className="m-2">
                      {isLoading ? (
                        <LoadingMessage />
                      ) : showOrganisationDashboardError ? (
                        <LoadingMessage message="We couldn't load organisation dashboard data right now." />
                      ) : staffStatsData?.length > 0 ? (
                        <OrganizationStatsChart teacherStatsData={staffStatsData} />
                      ) : (
                        <NoDataMessage />
                      )}
                    </div>
                  </div>
                </div>
              </Col>
            </Row>

            <Row className="mb-4">
              <Col xxl={6} lg={12} className="mt-2">
                <div className="expert-stat-card shadow-sm flex-column align-items-start" style={{ background: "#ffffff66", borderRadius: "20px", border: "1px solid #F4F7FE", padding: "15px 20px" }}>
                  <h2 className="f-24 mb-4" style={{ color: "#2B3674", fontWeight: "700" }}>Most popular shared videos</h2>
                  {isLoading || organisationDashboardSharedVideoPerSchoolStatus === "loading" ? (
                    <div
                      className="w-100 flex-grow-1 h-100 d-flex flex-column"
                      style={{
                        overflow: "hidden",
                      }}
                    >
                      <div className="text-center py-4 mt-3">
                        <LoadingMessage message="Fetching most shared videos..." />
                      </div>
                    </div>
                  ) : organisationDashboardSharedVideoPerSchoolStatus === "failed" ? (
                    <div className="text-center p-4 mt-3 flex-grow-1 h-100 d-flex flex-column w-100">
                      <p className="data-not-found-cmn">Unable to load videos. Please try again later.</p>
                    </div>
                  ) : organisationDashboardSharedVideoPerSchool?.length > 0 ? (
                    <>
                      {/*
                      <div className="Review-history mt-3 flex-grow-1 h-100 d-flex flex-column w-100">
                        <CustomCarousel
                          videoData={flattenedOrganizationSharedVideos}
                          type="Staff"
                          redirection={true}
                        />
                      </div>
                      */}
                      <div
                        className="w-100"
                        style={{
                          overflow: "auto",
                        }}
                      >
                        <table className="table table-borderless">
                          <thead>
                            <tr style={{ borderBottom: "1px solid #F4F7FE" }}>
                              <th
                                style={{
                                  color: "#2B3674",
                                  fontSize: "14px",
                                  fontWeight: "700",
                                  paddingBottom: "15px",
                                  width: "30%",
                                  maxWidth: "150px",
                                }}
                              >
                                Member Organisation
                              </th>
                              <th
                                style={{
                                  color: "#2B3674",
                                  fontSize: "14px",
                                  fontWeight: "700",
                                  paddingBottom: "15px",
                                }}
                              >
                                Top Shared Videos
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {organisationDashboardSharedVideoPerSchool.map(
                              (org, idx) => (
                                <tr
                                  key={idx}
                                  style={{
                                    borderBottom:
                                      idx !==
                                        organisationDashboardSharedVideoPerSchool.length -
                                        1
                                        ? "1px solid #F4F7FE"
                                        : "none",
                                  }}
                                >
                                  <td
                                    className="py-3"
                                    style={{
                                      color: "#2B3674",
                                      fontWeight: "500",
                                      fontSize: "15px",
                                      width: "30%",
                                      maxWidth: "150px",
                                      whiteSpace: "normal",
                                      wordBreak: "break-word",
                                    }}
                                    title={org.schoolName}
                                  >
                                    {org.schoolName}
                                  </td>
                                  <td className="py-3">
                                    <div className="d-flex align-items-center gap-3">
                                      {org.topSharedVideos?.map((video, vIdx) => (
                                        <OverlayTrigger
                                          key={vIdx}
                                          placement="top"
                                          overlay={
                                            <Tooltip>
                                              {video.title}: {video.shared || video.shares || video.sharesCount || video.shareCount || video.views || 0} shares
                                            </Tooltip>
                                          }
                                        >
                                          <div
                                            className="d-flex flex-column align-items-center"
                                            style={{ cursor: "pointer" }}
                                          >
                                            <img
                                              src={video.cover_url || video.thumbnail || video.image || fallbackThumb}
                                              alt={video.title}
                                              style={{
                                                width: "45px",
                                                height: "65px",
                                                borderRadius: "8px",
                                                objectFit: "cover",
                                                marginBottom: "2px",
                                              }}
                                            />
                                            <span
                                              style={{
                                                fontSize: "11px",
                                                color: "#707EAE",
                                                fontWeight: "600",
                                              }}
                                            >
                                              {video.shared || video.shares || video.sharesCount || video.shareCount || video.views || 0}
                                            </span>
                                          </div>
                                        </OverlayTrigger>
                                      ))}
                                    </div>
                                  </td>
                                </tr>
                              ),
                            )}
                          </tbody>
                        </table>
                      </div>
                    </>
                  ) : (
                    <div className="mt-3 flex-grow-1 h-100 d-flex flex-column w-100">

                      <NoDataMessage />
                    </div>
                  )}
                </div>
              </Col>
              <Col xxl={6} lg={12} className="mt-2">
                <div className="expert-stat-card shadow-sm flex-column align-items-start" style={{ background: "#ffffff66", borderRadius: "20px", border: "1px solid #F4F7FE", padding: "15px 20px" }}>
                  <h2 className="f-24 mb-4" style={{ color: "#2B3674", fontWeight: "700" }}>Most Viewed Categories</h2>
                  {isLoading ? (
                    <div
                      className="w-100"
                      style={{
                        overflow: "hidden",
                      }}
                    >
                      <div className="text-center py-4">
                        <LoadingMessage message="Loading categories..." />
                      </div>
                    </div>
                  ) : organisationDashboardCategoryPerSchool?.length > 0 ? (
                    <div
                      className="w-100"
                      style={{
                        overflow: "auto",
                      }}
                    >
                      <table className="table table-borderless">
                        <thead>
                          <tr style={{ borderBottom: "1px solid #F4F7FE" }}>
                            <th
                              style={{
                                color: "#A3AED0",
                                fontSize: "14px",
                                fontWeight: "700",
                                paddingBottom: "15px",
                                width: "30%",
                                maxWidth: "150px",
                              }}
                            >
                              Member Organisation
                            </th>
                            <th
                              style={{
                                color: "#A3AED0",
                                fontSize: "14px",
                                fontWeight: "700",
                                paddingBottom: "15px",
                              }}
                            >
                              Most Viewed Categories
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {organisationDashboardCategoryPerSchool.map(
                            (org, idx) => (
                              <tr
                                key={idx}
                                style={{
                                  borderBottom:
                                    idx !==
                                      organisationDashboardCategoryPerSchool.length -
                                      1
                                      ? "1px solid #F4F7FE"
                                      : "none",
                                }}
                              >
                                <td
                                  className="py-3"
                                  style={{
                                    color: "#2B3674",
                                    fontWeight: "500",
                                    fontSize: "15px",
                                    width: "30%",
                                    maxWidth: "150px",
                                    whiteSpace: "normal",
                                    wordBreak: "break-word",
                                  }}
                                  title={org.schoolName}
                                >
                                  {org.schoolName}
                                </td>
                                <td className="py-3">
                                  <div className="d-flex align-items-center gap-3">
                                    {org.topCategories?.map((cat, cIdx) => (
                                      <OverlayTrigger
                                        key={cIdx}
                                        placement="top"
                                        overlay={
                                          <Tooltip>
                                            {cat.title}: {cat.views} views
                                          </Tooltip>
                                        }
                                      >
                                        <div
                                          className="d-flex flex-column align-items-center"
                                          style={{ cursor: "pointer" }}
                                        >
                                          <img
                                            src={cat.image || fallbackThumb}
                                            alt={cat.title}
                                            style={{
                                              width: "30px",
                                              height: "30px",
                                              borderRadius: "8px",
                                              objectFit: "cover",
                                              marginBottom: "2px",
                                            }}
                                          />
                                          <span
                                            style={{
                                              fontSize: "11px",
                                              color: "#707EAE",
                                              fontWeight: "600",
                                            }}
                                          >
                                            {cat.views}
                                          </span>
                                        </div>
                                      </OverlayTrigger>
                                    ))}
                                  </div>
                                </td>
                              </tr>
                            ),
                          )}
                        </tbody>
                      </table>
                    </div>
                  ) : (
                    <NoDataMessage />
                  )}
                </div>
              </Col>
            </Row>
          </>

  );
};
